import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as builder from "../ducks/builder";
import { LayoutSplashScreen } from "./LayoutContext";
import MenuConfig from "./MenuConfig";
import checkPermissions from "../../app/utils/checkPermission";

function loadCss(href, anchor) {
  return new Promise((resolve, reject) => {
    const link = document.createElement("link");

    link.setAttribute("rel", "stylesheet");
    link.setAttribute("type", "text/css");

    link.onload = resolve;
    link.onerror = reject;

    link.setAttribute("href", href);

    anchor.parentNode.insertBefore(link, anchor.nextSibling);

    return link;
  });
}

/**
 * Used to synchronize current layout `menuConfig`, `layoutConfig` and
 * `htmlClassService` with redux store.
 */
export default function LayoutInitializer({
  styles,
  children,
  menuConfig,
  layoutConfig,
  htmlClassService
}) {
  const dispatch = useDispatch();
  const [loadedStyles, setLoadedStyles] = useState();
  const state = useSelector( ({ auth, builder }) => ({ auth, permissions: auth.user.permissions, builder }));

  const builderState = state.builder;

  const permissions = state.permissions;

  useEffect(() => {
    const menuConfig = JSON.parse(JSON.stringify(MenuConfig));

    menuConfig.header.items = menuConfig.header.items.map((i)=> checkPermissions(i, permissions) ).filter( e => e != null);
    menuConfig.aside.items = menuConfig.aside.items.map((i)=> checkPermissions(i, permissions) ).filter( e => e != null);

    dispatch(builder.actions.setMenuConfig(menuConfig));
  }, [dispatch, menuConfig, permissions]);

  useEffect(() => {
    if (layoutConfig.mpcon !== builderState.layoutConfig.mpcon) {
      dispatch(builder.actions.setLayoutConfigs(layoutConfig));
    }
  }, [dispatch, builderState, layoutConfig]);

  useEffect(() => {
    dispatch(builder.actions.setHtmlClassService(htmlClassService));
  }, [dispatch, htmlClassService]);

  useEffect(() => {
    if (!Array.isArray(styles)) {
      setLoadedStyles(styles);

      return;
    }

    const anchor = document.getElementById("layout-styles-anchor");

    Promise.all([...styles].reverse().map(href => loadCss(href, anchor))).then(
      () => {

        setLoadedStyles(styles);
      }
    );

    return () => {
      styles.forEach(href => {
        const link = document.querySelector(`link[href='${href}']`);

        if (link && link.parentNode) {
          link.parentNode.removeChild(link);
        }
      });
    };
  }, [styles]);

  return loadedStyles === styles &&
    htmlClassService === builderState.htmlClassServiceObjects ? (
    // Render content when `htmlClassService` synchronized with redux store.
    <>{children}</>
  ) : (
    // Otherwise sow loading splash screen.
    <LayoutSplashScreen />
  );
}
